<ng-template #heading>
    <sirius-heading [text]="resolvedTitle()" textStyleSize="m" [h]="3" />
</ng-template>

@if (hasAttributes()) {
    <sirius-chips
        class="card-catalog-attributes"
        [chips]="resolvedAttributes()"
        [ariaLabel]="'card.catalog.attributes' | translate"
    />
}

@if (resolvedImage(); as image) {
    <div class="card-catalog-image">
        <sirius-image-item [image]="image" [imageData]="imageData()" [autocrop]="true" />
    </div>
}

<div class="card-catalog-content">
    <div class="card-catalog-text">
        @if (hasLink() && !showCta()) {
            <a
                class="card-catalog-title-link card-catalog-link-anchor"
                [siriusLink]="resolvedLink()"
                (linkSelect)="onClick()"
            >
                <ng-container [ngTemplateOutlet]="heading" />
            </a>
        } @else {
            <ng-container [ngTemplateOutlet]="heading" />
        }
        @if (resolvedTeaserHtml()) {
            <sirius-text-html
                class="card-catalog-teaser"
                [html]="resolvedTeaserHtml()"
                textStyleSize="m"
                [lineClamp]="4"
            />
        }
    </div>
    @if (hasProperties()) {
        <dl class="card-catalog-specifications">
            @for (property of resolvedProperties(); track $index) {
                <div class="card-catalog-specification">
                    <dt class="sir-text-style-system-s-bold">{{ property.name }}</dt>
                    <dd class="sir-text-style-system-l">{{ property.value }}</dd>
                </div>
            }
        </dl>
    }
</div>

@if (showCta()) {
    <div class="card-catalog-link">
        <a
            class="card-catalog-link-anchor sir-text-style-paragraph-m-bold"
            [siriusLink]="resolvedLink()"
            (linkSelect)="onClick()"
        >
            <span class="card-catalog-link-context">{{ resolvedTitle() }} </span>
            {{ resolvedLink().title }}
            <sirius-icon name="arrow_right_small" />
        </a>
    </div>
}
